<script>
import { resolveBanobagiRightsCountdown } from "@/utils/banobagiAvailability";

const TICK_INTERVAL_MS = 1000;

export default {
  name: "BanobagiRightsCountdown",
  data() {
    return {
      now: Date.now(),
      timer: null
    };
  },
  computed: {
    units() {
      const { days, hours, minutes } = resolveBanobagiRightsCountdown(this.now);
      return [
        {
          key: "day",
          value: days,
          label: this.$t("banobagi_countdown_day") || "วัน"
        },
        {
          key: "hour",
          value: hours,
          label: this.$t("banobagi_countdown_hour") || "ชั่วโมง"
        },
        {
          key: "minute",
          value: minutes,
          label: this.$t("banobagi_countdown_minute") || "นาที"
        }
      ];
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = Date.now();
    }, TICK_INTERVAL_MS);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
};
</script>

<template>
  <section
    class="banobagi-countdown"
    role="timer"
    data-test="profile-rights-countdown"
  >
    <p class="banobagi-countdown__title">
      {{ $t("banobagi_rights_close_in") || "ปิดรับสิทธิ์ในอีก " }}
    </p>
    <div class="banobagi-countdown__units">
      <div
        v-for="unit in units"
        :key="unit.key"
        class="banobagi-countdown__unit"
      >
        <span
          class="banobagi-countdown__value"
          :data-test="`profile-rights-countdown-${unit.key}-value`"
        >
          {{ unit.value }}
        </span>
        <span class="banobagi-countdown__label">{{ unit.label }}</span>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.banobagi-countdown {
  margin: 24px 16px 0;
  color: #ffffff;
  text-align: center;
}

.banobagi-countdown__title {
  margin: 0 0 8px;
  font-size: var(--font-body-sm);
}

.banobagi-countdown__units {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.banobagi-countdown__unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.banobagi-countdown__unit + .banobagi-countdown__unit {
  border-left: 1px solid rgba(255, 255, 255, 0.5);
}

.banobagi-countdown__value {
  font-size: calc(var(--font-heading) * 1.75);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.banobagi-countdown__label {
  font-size: var(--font-body-sm);
}
</style>
